import { render } from "./AccountTypeOld.vue?vue&type=template&id=46b70de6&scoped=true"
import script from "./AccountTypeOld.vue?vue&type=script&lang=js"
export * from "./AccountTypeOld.vue?vue&type=script&lang=js"

import "./AccountTypeOld.vue?vue&type=style&index=0&id=46b70de6&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b70de6"]])

export default __exports__